import { render } from "./BeatsEntry.vue?vue&type=template&id=34610619"
import script from "./BeatsEntry.vue?vue&type=script&lang=js"
export * from "./BeatsEntry.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__